import _slicedToArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import React from "react";
var __jsx = React.createElement;
import { useEffect } from "react";
import Layout from "@/_LayoutsRelated/layout/Layout";
import { checkoutCart, getCart } from "@/apis/oils/cartApi";
import useMoyasarHook from "@/pages/checkout/CheckoutV2/hooks/useMoyasarHook";
import useHelpers from "@hooks/useHelpers";
import useTranslation from "@/i18n/useTranslation";
import MobileHeaderwithBackAndCancel from "@/_LayoutsRelated/mobileHeaders/mobileHeaderwithBackAndCancel/MobileHeaderwithBackAndCancel";
import "@/pages/checkout/moyasar/styles.css";
import useApi from "@hooks/useApi";
import { serverUrl } from "@globalConfig";
import Loader from "@componentsShared/Loader/Loader";
import { trackEvents } from "@/common/events/events";
import useWebView from "@hooks/useWebview";
import useIsWebView from "@hooks/useIsWebview";
var OIL_PAYMENT_SUMMARY_KEY = "oil_cart_payment_summary";
var MOYASAR_DIV_ID = "oil-cart-moyasar-payment";
// Derive product/quantity counts from the get-cart response. In webview the
// cart is rendered natively, so the React cart page never writes the
// localStorage summary — these counts are the only reliable source for the
// VAS analytics events.
var deriveCartCounts = function deriveCartCounts(blocks) {
  var _itemsBlock$content;
  var itemsBlock = blocks === null || blocks === void 0 ? void 0 : blocks.find(function (b) {
    return b.component_type === "cart_items";
  });
  var oilItems = ((_itemsBlock$content = itemsBlock === null || itemsBlock === void 0 ? void 0 : itemsBlock.content) !== null && _itemsBlock$content !== void 0 ? _itemsBlock$content : []).filter(function (b) {
    return b.component_type === "cart_item_oil";
  });
  return {
    products_count: oilItems.length,
    total_quantity: oilItems.reduce(function (sum, b) {
      var _b$content$count;
      return sum + ((_b$content$count = b.content.count) !== null && _b$content$count !== void 0 ? _b$content$count : 0);
    }, 0)
  };
};
var CartPaymentForm = function CartPaymentForm(_ref) {
  var paymentSession = _ref.paymentSession,
    cartCounts = _ref.cartCounts;
  var _useTranslation = useTranslation(["web_oils"]),
    tShort = _useTranslation.tShort;
  useMoyasarHook({
    divSelector: "#".concat(MOYASAR_DIV_ID),
    paymentSession: paymentSession,
    events: {
      on_initiating: function () {
        var _on_initiating = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
          var _paymentSession$metad, _paymentSession$metad2, _cartSummary$total_am;
          var orderId, stored, cartSummary, updatedSummary;
          return _regenerator().w(function (_context) {
            while (1) switch (_context.n) {
              case 0:
                orderId = (_paymentSession$metad = (_paymentSession$metad2 = paymentSession.metadata) === null || _paymentSession$metad2 === void 0 ? void 0 : _paymentSession$metad2.order_id) !== null && _paymentSession$metad !== void 0 ? _paymentSession$metad : "";
                stored = __IS_CSR__ ? localStorage.getItem(OIL_PAYMENT_SUMMARY_KEY) : null;
                cartSummary = stored ? JSON.parse(stored) : {}; // Prefer the cart-derived counts (always available, web + webview);
                // fall back to whatever the cart page may have stored.
                updatedSummary = _objectSpread(_objectSpread({}, cartSummary), {}, {
                  order_id: orderId,
                  products_count: cartCounts.products_count || cartSummary.products_count || 0,
                  total_quantity: cartCounts.total_quantity || cartSummary.total_quantity || 0,
                  total_amount: (_cartSummary$total_am = cartSummary.total_amount) !== null && _cartSummary$total_am !== void 0 ? _cartSummary$total_am : paymentSession.amount / 100
                });
                if (__IS_CSR__) {
                  localStorage.setItem(OIL_PAYMENT_SUMMARY_KEY, JSON.stringify(updatedSummary));
                }
                trackEvents("vas_payment_initiated", {
                  order_id: orderId,
                  products_count: updatedSummary.products_count,
                  total_quantity: updatedSummary.total_quantity,
                  total_amount: updatedSummary.total_amount
                });
                return _context.a(2, true);
            }
          }, _callee);
        }));
        function on_initiating() {
          return _on_initiating.apply(this, arguments);
        }
        return on_initiating;
      }(),
      on_completed: function () {
        var _on_completed = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
          return _regenerator().w(function (_context2) {
            while (1) switch (_context2.n) {
              case 0:
                return _context2.a(2);
            }
          }, _callee2);
        }));
        function on_completed() {
          return _on_completed.apply(this, arguments);
        }
        return on_completed;
      }()
    },
    template: {
      payButtonText: tShort("checkout/confirm_pay", {
        ns: "web_oils"
      })
    },
    internvalTimeoutSeconds: 60
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "container m-auto"
  }, /*#__PURE__*/React.createElement("div", {
    className: "h-full md:mt-32 m-auto px-2 md:p-10 md:pb-24 pb-20 rounded-2xl max-w-[665px] md:shadow-[0_0_10px_rgba(188,188,188,0.4)] md:border-solid md:border-[1px] border-gray-200"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "text-[#484848] md:text-start text-center mt-10 md:px-10 md:mt-2 mb-6 md:mb-10 text-lg md:text-xl font-bold",
    dir: "rtl"
  }, tShort("checkout/choose_payment", {
    ns: "web_oils"
  })), /*#__PURE__*/React.createElement("div", {
    id: MOYASAR_DIV_ID,
    className: "w-full"
  })));
};
var OilCartCheckoutPage = function OilCartCheckoutPage() {
  var _document$cookie$spli;
  var _useHelpers = useHelpers(),
    navigateToHard = _useHelpers.navigateToHard,
    navigateTo = _useHelpers.navigateTo;
  var _useTranslation2 = useTranslation(["web_oils"]),
    tShort = _useTranslation2.tShort;
  var webview = useWebView();
  var isWebView = useIsWebView();
  useEffect(function () {
    webview.showTitleBar(false)["catch"](function () {});
  }, [isWebView]);
  var cartId = __IS_CSR__ ? new URLSearchParams(window.location.search).get("cart_id") || ((_document$cookie$spli = document.cookie.split(";").map(function (c) {
    return c.trim();
  }).find(function (c) {
    return c.startsWith("cart_id=");
  })) === null || _document$cookie$spli === void 0 ? void 0 : _document$cookie$spli.slice("cart_id=".length)) || null : null;
  var baseUrl = __IS_CSR__ ? window.location.origin : serverUrl;
  var callbackUrl = "".concat(baseUrl, "/site/cart/oil-payment-status");
  var successUrl = callbackUrl;
  var failureUrl = callbackUrl;
  var _useApi = useApi([cartId], function () {
      if (!cartId) return Promise.resolve(null);
      return checkoutCart(cartId, successUrl, failureUrl);
    }),
    _useApi2 = _slicedToArray(_useApi, 3),
    loading = _useApi2[0],
    error = _useApi2[1],
    paymentSession = _useApi2[2];

  // Fetch the cart to derive products_count / total_quantity for the VAS
  // analytics events. The native webview cart never writes the localStorage
  // summary, so without this both counts are sent as 0.
  var _useApi3 = useApi([cartId], function () {
      return cartId ? getCart(cartId) : Promise.resolve(null);
    }),
    _useApi4 = _slicedToArray(_useApi3, 3),
    cartBlocks = _useApi4[2];
  var cartCounts = deriveCartCounts(cartBlocks);
  if (!cartId) {
    if (__IS_CSR__) navigateToHard("/site/cart");
    return null;
  }
  if (loading) {
    return /*#__PURE__*/React.createElement(Layout, {
      hideOrangeHeadBtn: true,
      disableLoader: true,
      headHideLinks: true,
      hideMenu: true,
      hideAppBanner: true,
      hideHeaderOnmobile: true
    }, /*#__PURE__*/React.createElement("div", {
      className: "min-h-screen flex items-center justify-center"
    }, /*#__PURE__*/React.createElement(Loader, {
      smallLoader: true
    })));
  }
  if (error || !paymentSession) {
    if (__IS_CSR__) navigateToHard("/site/cart");
    return null;
  }
  return /*#__PURE__*/React.createElement(Layout, {
    hideOrangeHeadBtn: true,
    disableLoader: true,
    headHideLinks: true,
    authenticationMsg: true,
    hideFooterWithoutAuthMsg: true,
    hideMenu: true,
    hideAppBanner: true,
    hideHeaderOnmobile: true,
    custommobileHeader: /*#__PURE__*/React.createElement(MobileHeaderwithBackAndCancel, {
      backFunction: function backFunction() {
        webview.openDeepLink(serverUrl + "/site/cart")["catch"](function () {
          navigateTo("/site/cart");
        });
      },
      buttonFunction: function buttonFunction() {
        webview.openDeepLink(serverUrl + "/site/cart")["catch"](function () {
          navigateTo("/site/cart");
        });
      }
    })
  }, /*#__PURE__*/React.createElement(CartPaymentForm, {
    paymentSession: paymentSession,
    cartCounts: cartCounts
  }));
};
export default OilCartCheckoutPage;